import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_13 = {
  key: 1,
  class: "text-info"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_26 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_27 = { class: "custom-search" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-8" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_33 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_36 = {
  class: "col-12",
  md: "6"
}
const _hoisted_37 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_41 = {
  key: 1,
  class: "text-info"
}
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { class: "dropdown" }
const _hoisted_46 = { class: "dropdown-menu" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 4 }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = {
  class: "col-12",
  md: "6"
}
const _hoisted_52 = {
  class: "col-12",
  md: "6"
}
const _hoisted_53 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_55 = { class: "modal-content p-15 p-md-40" }
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_59 = { class: "modal-content p-15 p-md-40" }
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_62 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_63 = { class: "modal-content p-15 p-md-40" }
const _hoisted_64 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.rowNote.note_ref), 1),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("p", null, [
          _cache[11] || (_cache[11] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.rowNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.rowNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createTextVNode(" | ENVOIE : ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.rowNote.sending_zone_name) + " " + _toDisplayString(_ctx.rowNote.sending_agency_name), 1),
          _cache[13] || (_cache[13] = _createTextVNode(" | RECEPTION :", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.rowNote.reception_zone_name) + " " + _toDisplayString(_ctx.rowNote.reception_agency_name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "List des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users1.per_page,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRows1()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.users1.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Chercher",
                    type: "text",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRows1())),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
                    class: "form-control"
                  }, null, 544), [
                    [_vModelText, _ctx.users1.searchTerm]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [16]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_13, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                    ], 64))
                  : (props.column.field === 'updated_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                    : (props.column.field === 'actions')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[21] || (_cache[21] = _createElementVNode("button", {
                              class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createElementVNode("i", { class: "flaticon-dots" })
                            ], -1)),
                            _createElementVNode("ul", _hoisted_18, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                }, _cache[19] || (_cache[19] = [
                                  _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Historique ", -1)
                                ]), 8, _hoisted_19)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.showDetails(props.row))
                                }, _cache[20] || (_cache[20] = [
                                  _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Infos ", -1)
                                ]), 8, _hoisted_20)
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users1,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Scan code suivi")
      ], -1)),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", null, "Code Suivi :", -1)),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Code Suivi",
                    type: "text",
                    id: "scanFocus",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.codeColis) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.codeColis]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[25] || (_cache[25] = _createElementVNode("button", {
                  class: "btn btn-success me-3 mb-3 mt-3",
                  type: "submit"
                }, [
                  _createElementVNode("i", { class: "ph ph-scan" })
                ], -1)),
                _createElementVNode("button", {
                  class: "btn btn-primary me-3 mb-3 mt-3",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
                }, _cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "ph ph-arrows-clockwise" }, null, -1)
                ]))
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("hr")
              ], -1))
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "List des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users2.per_page,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.users2.per_page) = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (_ctx.getRows2()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.users2.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Chercher",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getRows2())),
                    class: "form-control"
                  }, null, 544), [
                    [_vModelText, _ctx.users2.searchTerm]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[29] || (_cache[29] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [29]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_40, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_41, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[31] || (_cache[31] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_42, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'updated_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                  : (props.column.field === 'actions')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _cache[34] || (_cache[34] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_46, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                              }, _cache[32] || (_cache[32] = [
                                _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Historique ", -1)
                              ]), 8, _hoisted_47)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showDetails(props.row))
                              }, _cache[33] || (_cache[33] = [
                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Infos ", -1)
                              ]), 8, _hoisted_48)
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users2,
                  offset: 9,
                  onPaginate: _ctx.getRows2
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_56, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpenModal,
                  status: _ctx.statuts
                }, null, 8, ["colisId", "isOpen", "status"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_60, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpenModal
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_64, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getData,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}